import {
    ROOT,
    WARNING_METHOD,
    UPDATE_WARNING_METHOD,
    GET_ALL_ROOMS_INFO
  } from "@/_helpers/constant.js";
  
  import { requestOptions, handleResponse } from "@/_helpers";
  
  function get() {
    return fetch(ROOT + WARNING_METHOD, requestOptions.get())
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  function update(data) {
    return fetch(ROOT + UPDATE_WARNING_METHOD, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }

  function getAllRooms() {
    const data = {
        asc: false,
        keyword: "",
        limit: 1000,
        offset: 0,
        orderBy: "active",
        status: "1"
    }
    return fetch(ROOT + GET_ALL_ROOMS_INFO, requestOptions.post(data))
      .then(handleResponse)
      .then(data => {
        return data;
      });
  }
  
  export const service = {
    get,
    update,
    getAllRooms
  };
  